import { Button, Menu, MenuItem, MenuList, MenuPopover, MenuTrigger, Table, TableCell, TableHeader, TableHeaderCell, TableRow, Text, useFocusableGroup } from '@fluentui/react-components';
import { MoreHorizontalFilled } from '@fluentui/react-icons';
import { format, parseISO } from 'date-fns';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { WinnerEvent } from '../../../models';
import './WinnerEventsTable.scss';

const WinnerEventsTableImpl: React.FC = () => {
  const {
    winnerRequirementPageUiStore
  } = useStores();

  const focusableGroupAttr = useFocusableGroup({
    tabBehavior: 'limited-trap-focus',
  });

  const handleEditWinnerEvent = (winnerEvent: WinnerEvent): void => {
    winnerRequirementPageUiStore.setSelectedWinnerEvent(winnerEvent);
    winnerRequirementPageUiStore.setAddOrEditEventModalType('update');
  };

  const handleDeleteWinnerEvent = (winnerEvent: WinnerEvent): void => {
    winnerRequirementPageUiStore.setSelectedWinnerEvent(winnerEvent);
    winnerRequirementPageUiStore.setShowDeleteEventModal(true);
  };

  return (
    <Table className='winner-events-table'>
      <TableHeader>
        <TableRow>
          <TableHeaderCell>Name</TableHeaderCell>
          <TableHeaderCell>Event Type</TableHeaderCell>
          <TableHeaderCell>Date</TableHeaderCell>
          <TableHeaderCell>Start time</TableHeaderCell>
          <TableHeaderCell>End time</TableHeaderCell>
          <TableHeaderCell>Is time TBD</TableHeaderCell>
          <TableHeaderCell>Role</TableHeaderCell>
          <TableHeaderCell>Max Attendees</TableHeaderCell>
          <TableHeaderCell className='col-actions' />
        </TableRow>
      </TableHeader>
      <tbody>
        {
          winnerRequirementPageUiStore.hasWinnerEvent ?
            winnerRequirementPageUiStore.winnerEvents.map((event, index) => {
              return (
                <TableRow
                  key={index}
                >
                  <TableCell>
                    {event.displayName}
                  </TableCell>
                  <TableCell>
                    {event.eventType}
                  </TableCell>
                  <TableCell>
                    {format(parseISO(event.eventDate), 'yyyy-MM-dd')}
                  </TableCell>
                  <TableCell>
                    {event.startTime}
                  </TableCell>
                  <TableCell>
                    {event.endTime}
                  </TableCell>
                  <TableCell>
                    {event.isTimeTBD ? 'Yes' : 'No'}
                  </TableCell>
                  <TableCell>
                    {event.role}
                  </TableCell>
                  <TableCell>
                    {event.numberOfAttendees}
                  </TableCell>
                  <TableCell
                    className='col-actions'
                    tabIndex={0} {...focusableGroupAttr}
                  >
                    <Menu>
                      <MenuTrigger disableButtonEnhancement>
                        <Button
                          title='more'
                          appearance='subtle'
                          icon={<MoreHorizontalFilled />}
                        />
                      </MenuTrigger>
                      <MenuPopover>
                        <MenuList>
                          <MenuItem
                            onClick={() => handleEditWinnerEvent(event)}
                          >
                            Edit
                          </MenuItem>
                          <MenuItem
                            onClick={() => handleDeleteWinnerEvent(event)}
                          >
                            Delete
                          </MenuItem>
                        </MenuList>
                      </MenuPopover>
                    </Menu>
                  </TableCell>
                </TableRow>
              );
            }) : (
              <TableRow>
                <TableCell
                  colSpan={9}
                >
                  <Text
                    block
                    align='center'
                    italic
                  >
                    Sorry, currently there are no winner events to display.
                  </Text>
                </TableCell>
              </TableRow>
            )
        }
      </tbody>
    </Table>
  )
};

export const WinnerEventsTable = observer(WinnerEventsTableImpl);
